<template>
  <div>
    <!-- 提现 -->
    <el-dialog
    :title="$t('user_Index_TXSQ')"
      v-dialogDrag
      :visible.sync="cashVis"
      :width="yuyan == 'zh' ?'600px':'800px'"
      @close="close"
      >
      
      <el-form ref="withdrawal" :label-width="yuyan == 'zh' ?'120px':'180px'" :rules="rules" :model="withdrawal">
        <el-form-item :label="$t('KTXJE')+'：'">
          <div style="display: flex; flex-direction: row">
            <div><span style="color: #999;">RMB：</span>{{userInfo.amount}}</div>
            <div style="margin-left: 30px;"><span style="color: #999;">USD：</span>{{userInfo.us_amount}}</div>
          </div>
          </el-form-item>
        <!-- <span class="fs-16 m-v-20 d-block text-grey" :style="yuyan == 'zh' ? 'margin-left:38px;' : 0">{{$t('KTXJE')}}：${{userInfo.us_amount - userInfo.frozen_amount}}</span> -->
        <!-- 提现金额 -->
        <el-form-item :label="$t('user_Index_TXJE')+'：'" prop="amount">
          <!-- <el-input v-model="withdrawal.amount"></el-input> -->
          <el-input v-model="withdrawal.amount" class="input-with-select">
            <el-select v-model="withdrawal.acc_type" slot="prepend" style="width:90px;">
              <el-option v-for="(item,index) in account_type_list" :key="index" :label="item.label" :value="item.value"></el-option>
              <!-- <el-option label="RMB" value="rmb"></el-option>
              <el-option label="USD" value="usd"></el-option> -->
            </el-select>
          </el-input>
        </el-form-item>
        <!-- <el-form-item :label="$t('user_Index_TXJE')+'：'" prop="amount">
          <el-input
            type="number"
            v-model="withdrawal.RBM"
            @input="TBMoney($event,'RMB')"
            style="width:150px;margin-right:5px;"
          >
            <template slot="prepend">￥</template>
          </el-input>
          <span style="position:relative;">
            <img style="width:70px;height:20px;" src="../assets/images/change.png" alt />
            <span
              class="fs-14"
              style="position: absolute;top: -21px;display: inline-block;width: 70px;text-align: center;left: 0;"
            >{{rate}}</span>
            <span
              style="position: absolute;top: 14px;left: 50%;margin-left: -28px;"
              :style="yuyan == 'zh' ? '':'width: 300px;'"
              @click="openRate()"
              class="fs-14 text-blue cursor-pointer"
            >{{$t('user_Index_JRHL')}}</span>
          </span>
          <el-input
            type="number"
            v-model="withdrawal.amount"
            @input="TBMoney($event,'US')"
            style="width:150px;margin-left:5px;"
          >
            <template slot="prepend">$</template>
          </el-input>
        </el-form-item> -->

        <!-- 提现方式 -->
        <!-- <el-form-item :label="$t('user_Index_TXFS')+'：'" prop="cash_method">  
          <el-select v-model="withdrawal.cash_method" :placeholder="$t('user_Index_QXZ')" style="width:100%" @change='methodChange()'>
            <el-option :label="$t('user_Index_YHK')" :value="2"></el-option>
            <el-option   :label="$t('user_Index_WEIXIN')" :value="4"></el-option>
            <el-option   :label="$t('user_Index_ZHIFUBAO')" :value="5"></el-option>
          </el-select>
        </el-form-item>-->
        <!-- 收款码 -->
        <!-- <el-form-item label="支付宝收款码：" prop="payment_code">
          <img :src="picImg+withdrawal.payment_code" style="width:120px;height:120px;">
        </el-form-item>
        <el-form-item label="微信收款码：" prop="payment_code">
          <img :src="picImg+withdrawal.payment_codewx" style="width:120px;height:120px;">
        </el-form-item>
          <el-form-item  :label="$t('user_TX_SKZH')+'：'" prop="payment_code">
            <el-input :disabled="true" v-model="withdrawal.payment_code"></el-input>   
          </el-form-item>
          <el-form-item  label="收款姓名" prop="payment_code">
            <el-input :disabled="true" v-model="withdrawal.bank_name"></el-input>   
          </el-form-item>
          <el-form-item label="开户行名称" prop="payment_code">
            <el-input :disabled="true" v-model="withdrawal.open_bank"></el-input>   
        </el-form-item>-->
        <!-- </div> -->

        <!-- 提现说明 -->
        <el-form-item :label="$t('user_TX_TXSM')+'：'">
          <el-input v-model="withdrawal.remark" type="textarea" :rows="2"></el-input>
        </el-form-item>
        <el-form-item label="发票上传：">
          <el-input clearable v-model="withdrawal.invoice_money" style="width:300px">
            <template slot="append">{{withdrawal.acc_type==2?'USD':'RMB'}}</template>
          </el-input>
        </el-form-item>
        <el-form-item label="">
          <div style="width: 400px;">
            <el-upload
              class="upload-demo"
              :action="$host.file+'/api/a_u/upload_file'"
              :on-success="txFormUploadSuccess"
              :on-remove="txFormUploadRemove"
              :limit="1"
              :on-exceed="txFormUploadExceed">
              <el-button size="small" type="primary">上传发票</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png/zip/rar文件，且不超过500kb</div>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- 取消 -->
        <el-button @click="cashVis=false" class="button-radius-5px">{{$t('pay_qx')}}</el-button>
        <!-- 确定 -->
        <el-button
          type="primary"
          class="button-radius-5px"
          @click="submitCash('withdrawal')"
        >{{$t('user_Index_QD')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { cashSubmit, usdToCny } from "@/Inspector_api/index";
import check from "@/check/check";
import { rate } from "@/api/customerManagementAdd";
export default {
  data() {
    return {
      // userInfo:{},
      //提现
      cashVis: false,
      account_type_list:[
        { label: 'RMB', value: 1},
        { label: 'USD', value: 2},
      ],
      withdrawal: {
        amount: "",
        open_bank: "",
        bank_name: "",
        cash_method: "",
        payment_code: "",
        remark: "",
        payment_codewx: "",
        acc_type: 1,
        invoice_money:""
      },
      rules: {
        // amount: [{ required: true, message: '该字段不能为空'}],
        // cash_method: [{ required: true, message: '该字段不能为空'}],
        // payment_code: [{ required: true, message: '该字段不能为空'}],
      },
      theamount: "",
      rate: 0,
      userInfo: {},
      message:''
    };
  },
  props: {
    showcash: { default: false }
  },
  computed: {
    // userInfo(){
    //   return JSON.parse(localStorage.getItem('userInfo'))
    // }
  },
  watch: {
    showcash: {
      handler(val) {
        if (val == true) {
          this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
          this.cashvisOpen();
          this.withdrawal.wx_img = this.userInfo.wx_img
            ? this.userInfo.wx_img
            : "";
          this.withdrawal.ali_img = this.userInfo.ali_img
            ? this.userInfo.ali_img
            : "";
          this.withdrawal.bank_card = this.userInfo.bank_card
            ? this.userInfo.bank_card
            : "";
          this.withdrawal.paypal = this.userInfo.paypal
            ? this.userInfo.paypal
            : ""; //开户行
          this.withdrawal.veem = this.userInfo.veem ? this.userInfo.veem : ""; //收款人姓名
          console.log(this.withdrawal);
        }
        this.cashVis = val;
      }
    }
  },
  methods: {
    openRate() {
      let path = "https://finance.sina.com.cn/money/forex/hq/USDCNY.shtml";
      let locale = localStorage.getItem("locale");
      locale != "zh"
        ? (path = "https://usd.fxexchangerate.com/")
        : (path = "https://finance.sina.com.cn/money/forex/hq/USDCNY.shtml");
      window.open(path, "_blank");
    },
    async getRate() {
      const res = await rate();
      const { code, data, msg } = res.data;
      if (code == 200) {
        this.rate = data;
      }
    },
    TBMoney(val, val1) {
      if (val1 == "RMB") {
        this.withdrawal.amount = this.withdrawal.RBM / this.rate;
      } else {
        this.withdrawal.RBM = this.withdrawal.amount * this.rate;
      }
    },
    //弹窗关闭
    close() {
      this.$emit("closeCash", { val: this.cashVis, type: 1 });
    },
    //上传超出数量限制
    txFormUploadExceed() {
      check.error.call(this, "文件只支持上传一个哦!");
    },
    //上传成功后移除文件
    txFormUploadRemove(file, fileList) {
      this.withdrawal.invoice_file = "";
    },
    //上传成功的回调 --美元充值
    txFormUploadSuccess(response, file, fileList) {
      let {
        code,
        data: { file_path },
        msg,
      } = response;
      if (code == 200) {
        check.success.call(this, msg);
        this.withdrawal.invoice_file = file_path;
      } else {
        check.error.call(this, msg);
      }
    },
    
    //上传图片成功
    handleAvatarSuccess(res, file, fileList) {
      this.withdrawal.payment_code = res.data.file_path;
    },
    //上传图片之前
    beforeAvatarUpload(file) {
      const isLt30M = file.size / 1024 / 1024 < 30;
      if (!isLt30M) {
        this.$message.error($t("user_Index_SC30"));
      }
      return isLt30M;
    },
    // 提现弹窗
    cashvisOpen() {
      this.withdrawal = {...this.withdrawal,
        amount: "",
        open_bank: "",
        bank_name: "",
        cash_method: "",
        payment_code: this.userInfo.wx_img ? this.userInfo.wx_img : "",
        remark: ""
      };
      this.theamount =
        this.userInfo.amount_type == 1
          ? this.userInfo.amount
          : this.userInfo.us_amount;
      console.log(this.theamount);
    },
    //提现
    submitCash(withdrawal) {
      this.$refs[withdrawal].validate(valid => {
        if (valid) {
          if (check.isNumber(this.withdrawal.amount)) {
            check.error.call(this, this.$t("user_Index_JEGS"));
            return;
          }
          if (this.withdrawal.amount == "") {
            this.$message.error(this.$t("user_Index_TXJEBNWK"));
            return;
          }
          if (Number(this.withdrawal.amount) > Number(this.theamount)) {
            this.$message.error(this.$t("user_Index_TXJEDYZ"));
            return;
          }
          if (
            this.withdrawal.wx_img == "" &&
            this.withdrawal.ali_img == "" &&
            this.withdrawal.bank_card == "" &&
            this.withdrawal.paypal == "" &&
            this.withdrawal.veem == ""
          ) {
            // this.$message.error(this.$t("user_Index_QTXFS"));
            this.message = this.$message({
              showClose: true,
              dangerouslyUseHTMLString: true,
              message:
                this.$t("user_Index_QTXFS") +
                `<a style="padding-left:10px;color: #61c3ff;cursor: pointer;">` +
                this.$t("ty_ljqw")+`</a>`,
              type: "error",
              duration: 0
            });
            this.message.$el.querySelector("a").onclick = () => {
              // this.$router.push("/insp/accountManage");
              // 调用父组件的提现方式方法
              this.message.close();
              this.cashVis = false;
              this.$parent.getuserInfo('open');
              
            };
            return;
          }

          this.Submission();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 美元转人民币
    async usdToCny1() {
      const res = await usdToCny({ money: this.withdrawal.amount });
      const { data, code } = res.data;
      if (code == 200) {
        this.withdrawal["money"] = data.data.money;
      }
    },
    async Submission() {
      const resData = await usdToCny({ money: this.withdrawal.amount });
      this.withdrawal["money"] = resData.data.data.data.money;
      const res = await cashSubmit(this.withdrawal);
      const { code, data, msg } = res.data;
      if (code == 200) {
        this.$message.success(msg);
        this.cashVis = false;
        this.$emit("closeCash", { val: this.cashVis, type: 2 });
      }
    },
    //提现方式改变
    methodChange() {
      // console.log(this.withdrawal.cash_method)
      if (this.withdrawal.cash_method == 4) {
        this.withdrawal.payment_code = this.userInfo.wx_img
          ? this.userInfo.wx_img
          : "";
      } else if (this.withdrawal.cash_method == 5) {
        this.withdrawal.payment_code = this.userInfo.ali_img
          ? this.userInfo.ali_img
          : "";
      } else {
        //银行卡
        this.withdrawal.payment_code = this.userInfo.bank_card
          ? this.userInfo.bank_card
          : "";
        this.withdrawal.open_bank = this.userInfo.open_bank
          ? this.userInfo.open_bank
          : ""; //开户行
        this.withdrawal.bank_name = this.userInfo.bank_card
          ? this.userInfo.bank_name
          : ""; //收款人姓名
      }
      console.log(this.withdrawal);
    }
  },
  created() {
    // this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    // console.log(this.userInfo)
    this.getRate();
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.cashvisOpen();
    this.withdrawal.wx_img = this.userInfo.wx_img
      ? this.userInfo.wx_img
      : "";
    this.withdrawal.ali_img = this.userInfo.ali_img
      ? this.userInfo.ali_img
      : "";
    this.withdrawal.bank_card = this.userInfo.bank_card
      ? this.userInfo.bank_card
      : "";
    this.withdrawal.paypal = this.userInfo.paypal
      ? this.userInfo.paypal
      : ""; //开户行
    this.withdrawal.veem = this.userInfo.veem ? this.userInfo.veem : ""; //收款人姓名
    this.cashVis = this.showcash;
  },
  mounted() {}
};
</script>


<style lang="scss" scoped>
.org {
  color: $--color-primary;
}
.borwn {
  color: #90613a;
}
.title /deep/ .el-card__body {
  padding: 12px;
}
.amount /deep/ .el-card__body {
  padding: 10px;
}
.levelInfo /deep/ .el-card {
  height: 110px;
}
/deep/ .subMenu {
  background-color: #ffffff;
}
.amap-wrapper {
  width: 99%;
  height: 400px;
}
</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>